import React from "react";
import { Modal } from "react-blueprint-library";
import "../../assets/stylesheets/LostDataModal.scss";
import { isSafari } from "../../common/Functions";

export default function LostDataModal({
  isOpen = false,
  handleClose = () => {},
  handleProceed = () => {},
}) {
  return (
    <div>
      <div id="lostDataModal"></div>
      <div>
        <Modal
          id="lostDataModal"
          show={isOpen}
          className={isSafari() ? "modal-md safari-only-wrapper" : "modal-md"}
          title=""
        >
          <div className="modal-body">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="modal-header">
                    <h2>
                      Data on this page may be lost. <br />
                      Do you wish to proceed?
                    </h2>
                    <div>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close modal dialog"
                        onClick={handleClose}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p>
                    We are unable to save partially complete pages at this time.
                    Please complete this page to avoid losing the data you have
                    entered.
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                variant="primary"
                onClick={handleClose}
              >
                No, Stay on this page
              </button>
              <button
                type="button"
                className="btn btn-link"
                onClick={handleProceed}
              >
                Yes, proceed without saving
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}
